import React from 'react';
import PropTypes from 'prop-types';

const StatsTile = ({ title, value }) => {
  return (
    <div className={`stats-tile flex-1 p-3 d-flex flex-column justify-content-between`}>
      <div className="f-500 f-grey mb-2">{title}</div>
      <div className="f-18 f-500 f-black">{value}</div>
    </div>
  );
};

StatsTile.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default StatsTile; 